import { Outlet, useOutletContext } from 'react-router-dom'

import { TrainingSessionsByEmployeeDataTableQuery } from 'generated/resources/datatable.graphql'
import { TrainingMembershipFragment } from 'generated/resources/graphql'

type TrainingsSessionAccessMembership = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<TrainingSessionsByEmployeeDataTableQuery['trainings']>['sessionsConnection']
    >['edges'][0]
  >['node']
>

const EmployeeSessionModalCertificates = () => {
  const { employeeId, employeeAccessId, trainingId, session, trainingMemberships } =
    useOutletContext<{
      employeeId: string
      employeeAccessId: string
      trainingId: string
      session: TrainingsSessionAccessMembership
      trainingMemberships: TrainingMembershipFragment[]
    }>()

  const trainingMembership = trainingMemberships.find(
    (membership) => membership.trainingId === trainingId && membership.accessId === employeeAccessId
  )
  return (
    <Outlet context={{ employeeId, employeeAccessId, trainingId, session, trainingMembership }} />
  )
}

export default EmployeeSessionModalCertificates
